import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M15 6.39a.74.74 0 0 0-.59-.51l-3.92-.64-1.82-3.58a.73.73 0 0 0-.28-.27l-.19-.11a.76.76 0 0 0-.21 0 .58.58 0 0 0-.19 0 .51.51 0 0 0-.17.07.69.69 0 0 0-.28.28L5.53 5.24l-3.92.64a.75.75 0 0 0-.41 1.26l2.86 2.91-.72 3.82a.74.74 0 0 0 .73.89.68.68 0 0 0 .34-.08L8 12.9l3.59 1.78a.64.64 0 0 0 .33.08.74.74 0 0 0 .45-.15.76.76 0 0 0 .29-.74l-.72-3.82 2.85-2.91a.73.73 0 0 0 .21-.75Zm-4.41 2.89a.76.76 0 0 0-.2.66l.51 2.73-2.52-1.26H8.2L8 11.3a.58.58 0 0 0-.19 0l-.19.08-2.53 1.29.51-2.73a.73.73 0 0 0-.2-.66L3.28 7.13l2.87-.47a.75.75 0 0 0 .55-.41L8 3.67l1.29 2.58a.75.75 0 0 0 .55.41l2.87.47Zm-2.21 2.13h-.09Zm-.58-.08-.19.08Z';
const draw24px =
  'M20.71,10a.74.74,0,0,0-.59-.5L15,8.65,12.67,4l0,0a.59.59,0,0,0-.28-.28l-.16-.07a.66.66,0,0,0-.46,0,.07.07,0,0,0-.06,0l-.06,0a.59.59,0,0,0-.28.28l0,0L9,8.65l-5.11.84a.73.73,0,0,0-.59.5.75.75,0,0,0,.17.76l3.73,3.79-.94,5a.74.74,0,0,0,.28.73.76.76,0,0,0,.45.15.68.68,0,0,0,.34-.08L12,18l4.68,2.33a.64.64,0,0,0,.33.08.74.74,0,0,0,.45-.15.75.75,0,0,0,.29-.73l-.94-5,3.72-3.79A.74.74,0,0,0,20.71,10Zm-5.25,3.78a.78.78,0,0,0-.2.67L16,18.33l-3.6-1.8-.2-.08a.63.63,0,0,0-.19,0,.76.76,0,0,0-.21,0,.75.75,0,0,0-.18.08L8,18.33l.74-3.89a.76.76,0,0,0-.21-.67l-3-3,4.06-.66a.76.76,0,0,0,.55-.4L12,6l1.84,3.67a.76.76,0,0,0,.55.4l4.06.66Zm-3.67,2.68a.75.75,0,0,0-.18.08l.05,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const StarIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'star'),
) as IconWithRender;

StarIcon.displayName = 'StarIcon';
StarIcon.propTypes = Icon.propTypes;
StarIcon.renderIcon = (props) => <StarIcon {...props} />;
export default StarIcon;
